export var AcceptanceAction = /*#__PURE__*/ function(AcceptanceAction) {
    AcceptanceAction["ACCEPTANCE_ACTION_UNKNOWN"] = "ACCEPTANCE_ACTION_UNKNOWN";
    AcceptanceAction["CHECK_OFF_BOX"] = "CHECK_OFF_BOX";
    AcceptanceAction["ENROLMENT"] = "ENROLMENT";
    AcceptanceAction["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    return AcceptanceAction;
}({});
